// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOperation_container__1ZEZZ","header":"NewOperation_header__2nHwx"};